import ProfileDetails from './details.vue'
export default ProfileDetails